import 'inventory-listing/components/OrderBy/OrderBy.scss';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { initial, last, values, map } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { InputDropDown } from '@sm360/widget-commons-forms';
import { SessionStorageService } from '@sm360/widget-commons-general';

import * as Actions from 'inventory-listing/actions/listingUsedActions.js';
import SORTINGS from 'inventory-listing/constants/sortings';

class ListingPaymentOrderBy extends React.Component {
    constructor(props) {
        super(props);

        let searchSort = map(values(SORTINGS), (sort) => ({
            ...sort,
            label: LocaleService.t(sort.transKey),
        }));
        if (!props.allowSortByDefault) {
            searchSort = searchSort.filter((sort) => sort.value !== SORTINGS.DEFAULT.value);
        }

        let vehicleSort = props.defaultSort;

        if (SessionStorageService.get('vehicleSorting')) {
            vehicleSort = JSON.parse(SessionStorageService.get('vehicleSorting'));
        }

        this.state = {
            sortSelected: vehicleSort,
            searchSort,
        };
        this.sortChange = this.sortChange.bind(this);
    }

    sortChange(option) {
        SessionStorageService.set('vehicleSorting', JSON.stringify(option.value));
        if (option.value === SORTINGS.DEFAULT.value) {
            this.props.actions.resetVehicleSortingToDefault();
        } else {
            const splitOptions = option.value.split('_');

            this.props.actions.updateVehicleSorting(initial(splitOptions).join('_'), last(splitOptions));
        }
        this.setState({
            sortSelected: option.value,
        });
    }

    render() {
        return (
            <div className="sort order-by-component">
                <InputDropDown
                    name="purchaseMethodSort"
                    value={this.state.sortSelected}
                    options={this.state.searchSort}
                    placeholder={LocaleService.t('SORT_BY')}
                    valueChange={this.sortChange}
                    classNames={['input-dropdown']}
                />
            </div>
        );
    }
}

ListingPaymentOrderBy.defaultProps = {
    allowSortByDefault: false,
};
ListingPaymentOrderBy.propTypes = {
    actions: React.PropTypes.shape({
        updateVehicleCriteria: React.PropTypes.func.isRequired,
        updateVehicleSorting: React.PropTypes.func.isRequired,
        resetVehicleSortingToDefault: React.PropTypes.func.isRequired,
    }),
    allowSortByDefault: React.PropTypes.bool,
    defaultSort: React.PropTypes.string.isRequired,
};

ListingPaymentOrderBy.displayName = 'ListingPaymentOrderBy';

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export { ListingPaymentOrderBy };
export default connect(
    null,
    mapDispatchToProps
)(ListingPaymentOrderBy);



// WEBPACK FOOTER //
// ./client/src/components/OrderBy/OrderBy.jsx